import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "select2/dist/js/select2.min.js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";

export const BASE_URL = process.env.REACT_APP_BASE_URL;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <GoogleOAuthProvider clientId="826431167947-3lpf76f4hqfud8p9jafrapkv8huvhg8j.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </>
);

reportWebVitals();
